import { ApiSubClient } from './ApiSubClient';

export interface AdminUser {
  actorId: number;
  email: string | null;
  displayName: string | null;
  admin: boolean;
  createdAt: string;
  passwordSet: boolean;
}

export class AdminClient extends ApiSubClient {
  createUser = async (email: string) => {
    const response = await this.core.post<{ actorId: number; email: string }>(
      '/admin/create_user',
      { email },
      this.core.SERVICES.api
    );
    return response;
  };

  listUsers = async () => {
    const response = await this.core.get<{ users: AdminUser[] }>('/admin/list_users', this.core.SERVICES.api);
    return response.users;
  };

  updateUser = async (
    actorId: number,
    data: { email?: string; displayName?: string; admin?: boolean }
  ) => {
    const response = await this.core.post<{ user: AdminUser }>(
      '/admin/update_user',
      { actorId, ...data },
      this.core.SERVICES.api
    );
    return response.user;
  };

  deleteUser = async (actorId: number) => {
    return this.core.post('/admin/delete_user', { actorId }, this.core.SERVICES.api);
  };
}
